import { View } from 'react-native';
import i18n from 'src/app/i18n';
import { TestIDs } from 'src/constants/testIDs.constants';
import { useStore } from 'src/contexts/StoreContext';
import BaseModal from '../../base-modal/BaseModal';
import { useEffect } from 'react';
import { DYNAMIC_MODAL_ACTIONS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { TOAST_IDS } from '../../../toast/Toast.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { MODAL_CUT_CONFIRMATION_TYPE } from './ModalCutConfirmationAlert.types';

export const ModalCutConfirmationAlert = ({
  dynamicModalVisible,
  dynamicModalLayer: { actionCallback, id },
  type,
}: DynamicModalProps) => {
  const {
    dynamicModal: {
      closeModal,
      activeModal: { modalCutType },
    },
    toastStore: { hideToast },
  } = useStore();

  const handleClose = () => {
    closeModal();
    amplitude.trackEvent(AnalyticsEvents.personalize.photoFrameSaveOptionClick, { option: 'close' });
  };

  useEffect(() => {
    hideToast(TOAST_IDS.CutsCheckAlert);
  }, []);

  return (
    <BaseModal
      testID={TestIDs.CUT_CONFIRMATION_ALERT}
      modalIcon={
        <View style={{ width: 92, height: 92 }}>
          <Illustration
            name={modalCutType == MODAL_CUT_CONFIRMATION_TYPE.CONFIRM ? ILLUSTRATION_NAMES.Photo : ILLUSTRATION_NAMES.Cut}
          />
        </View>
      }
      title={i18n.t(`modal-cut-confirmation-alert:title-${modalCutType}`)}
      description={i18n.t(`modal-cut-confirmation-alert:description-${modalCutType}`)}
      confirmText={i18n.t(`modal-cut-confirmation-alert:continue-${modalCutType}`)}
      handleConfirm={() => actionCallback(DYNAMIC_MODAL_ACTIONS.CONTINUE)}
      onClose={handleClose}
      onCloseOutside={handleClose}
      isVisible={dynamicModalVisible}
      type={type}
      id={id}
    />
  );
};
